import React from "react"

import { formatKeyboardShortcut } from "#React/constants/KeyboardShortcuts"
import Badge from "#React/ui/Badge"

type KeyboardShortcutProps = {
  shortcut: string
  className?: string
}

const KeyboardShortcut = ({ shortcut, className }: KeyboardShortcutProps) => {
  const parts = formatKeyboardShortcut(shortcut)

  return (
    <Badge border className={className}>
      {parts}
    </Badge>
  )
}

export type { KeyboardShortcutProps }
export default KeyboardShortcut
